import React from 'react';
import useApiPost from './useApiPost';

const buildFormData = ({ uId, bId, fileId, newTitle, fileType, filename, file, saveSameTitle }) => {
  let formData = new FormData();
  formData.set('hID', 'editAttachment');
  formData.set('bID', bId);
  formData.set('uID', uId);
  formData.set('fileId', fileId);
  formData.set('title', newTitle);
  formData.set('fileType', fileType);
  formData.set('fileName', filename);
  formData.set('file', file);
  formData.set('checkTitle', !saveSameTitle);
  return formData;
};

export default function useSaveAttachment() {
  const { loading, handlePost } = useApiPost();

  const saveAttachment = React.useCallback(
    ({ uId, bId, fileId, newTitle, fileType, filename, file, saveSameTitle, ...other }) => {
      handlePost({
        data: buildFormData({ uId, bId, fileId, newTitle, fileType, filename, file, saveSameTitle }),
        ...other
      });
    },
    [handlePost]
  );

  return { saveAttachment, loading };
}
